export const encodeSeoUrl = (urlToEncode: string): string => {
    return decodeURIComponent(
        Array.prototype.map
            .call(atob(urlToEncode), function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
    )
}
